export const SET_REPORT_DATA = 'ReportsGlobalContext.SET_REPORT_DATA';
export const SET_REPORT_META_DATA = 'ReportsGlobalContext.SET_REPORT_META_DATA';
export const SET_API_PARAM = 'ReportsGlobalContext.SET_API_PARAM';
export const SET_INIT_API_PARAMS = 'ReportsGlobalContext.SET_INIT_API_PARAMS';
export const SET_SHOW_LOADER = 'ReportsGlobalContext.SET_SHOW_LOADER';